export function ShareToX() {
  const handleShareToX = () => {
    const text = `Just wrapped up building a card flipping game on @ritualnet testnet.

It's live now, simple, fast, and a fun way to experience what Ritual can do.

👉 Try it here: ritual-flip-card-game.fun

Would love for you guys to test it out and share feedback. 

Let's push the ecosystem forward.

#Ritualnet #Ritual @ritualnet`;
    
    const encodedText = encodeURIComponent(text);
    const originalTweetId = '2053660719837827221';
    const xUrl = `https://x.com/intent/tweet?text=${encodedText}&quote_tweet_id=${originalTweetId}`;
    window.open(xUrl, '_blank');
    
    window.gtag?.("event", "share_to_x");
  };

  return (
    <button className="btn" onClick={handleShareToX}>
      Share to X
    </button>
  );
}
